import React from "react";
import TextMedium from "../TextComponent/TextMedium";
import { ResponsivePie } from "@nivo/pie";

import { ReactComponent as TimeIcon } from "../../../build/images/icontime.svg";
import { ReactComponent as MathIcon } from "../../../build/images/mathicon.svg";
import { ReactComponent as UserIcon } from "../../../build/images/userremove.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";

export default function CardAbandonment({
  title,
  timeOfAbandoned,
  level,
  width,
  classname = "",
}) {
  let data = [];

  if (level === 100) {
    data = [
      {
        id: "erlang",
        label: "erlang",
        value: level,
        color: "#1E88E5",
      },
    ];
  } else if (level === "0.00") {
    data = [
      {
        id: "erlang",
        label: "erlang",
        value: level,
        color: "#1E88E5",
      },
      {
        id: "go",
        label: "go",
        value: 100 - level,
        color: "#bbdbf7",
      },
    ];
  } else {
    data = [
      {
        id: "erlang",
        label: "erlang",
        value: level,
        color: "#1E88E5",
      },
      {
        id: "go",
        label: "go",
        value: 100 - level,
        color: "#FFFFFF",
      },
    ];
  }

  let paddingPercentage = "37%";

  if (level < 10 && level !== 0) {
    paddingPercentage = "22%";
  }

  if (level > 10) {
    paddingPercentage = "18%";
  }

  return (
    <div className={`manager-component__card-queue ${classname}`}>
      <div className="manager-component__card-queue__icon">
        <div className="manager-component__card-queue__icon__title">
          <MathIcon />
          <TextMedium text={title} color="gray" />
        </div>
      </div>
      {!isNaN(level) ? (
        <>
          <div
            className={
              width === "small"
                ? "manager-component__card-queue__container small"
                : "manager-component__card-queue__container"
            }
          >
            <div className="manager-component__card-queue__container-chart">
              <ResponsivePie
                data={data}
                margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                startAngle={0}
                innerRadius={0.85}
                cornerRadius={12}
                fit={false}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                isInteractive={false}
                borderColor={{
                  from: "color",
                  modifiers: [["darker", 0.2]],
                }}
                enableArcLinkLabels={false}
                enableArcLabels={false}
                colors={{ datum: "data.color" }}
              />
              <div
                className="manager-component__card-queue__root-overlay"
                style={{ paddingLeft: paddingPercentage }}
              >
                <strong>{level}%</strong>
              </div>
            </div>
            <div
              className="manager-component__card-queue__box-contents"
              style={{ paddingTop: "16px" }}
            >
              {timeOfAbandoned.map((queue, index) => (
                <>
                  <div className="manager-component__card-queue__box-contents__itens">
                    <div className="manager-component__card-queue__box-contents__itens-icon">
                      {index === 0 ? <UserIcon /> : <TimeIcon />}
                    </div>
                    <div className="manager-component__card-queue__box-contents__itens-text">
                      <h3>{queue.time}</h3>
                      <span>{queue.title}</span>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className="manager-component__card-queue__box-empty">
          <div className="manager_empty-state__card_queue">
            <EmptyState />
          </div>
        </div>
      )}
    </div>
  );
}
